import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const CACHE_PATH = 'cache'

export function clearCache(userId) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${CACHE_PATH}/clearCache`, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
